import { SvgIcon, SvgIconProps } from '@mui/material';

const ListIcon = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none" {...props}>
      <path
        d="M5.66667 1H16.5M5.66667 6H16.5M5.66667 11H16.5M1.5 1H1.50833M1.5 6H1.50833M1.5 11H1.50833"
        stroke="#667085"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ListIcon;
